import React from 'react'
import { RefreshButton as RefreshButtonCore } from '@ztechapps/webui.button'
import { useBlogItemContext } from './Context'

export const RefreshButton = () => {
  const { documentResult } = useBlogItemContext()

  return <RefreshButtonCore loading={documentResult?.loading} refetch={documentResult?.refetch} />
}
